<template>
    <div class="apply_value_cell">
		<!-- Icon + Tooltip -->
		<el-tooltip v-if="params.iconConfig.showCondition(params.data)"
					placement="left" :open-delay="300"
		>
			<span slot="content" v-html="params.iconConfig.iconTooltip"></span>
			<i class="apply_value_icon" :class="params.iconConfig.iconClass"/>
		</el-tooltip>
		<!-- Value -->
        <span>{{params.valueFormatted}}</span>
		<!-- Apply button -->
        <div v-if="params.value || params.showAlways" class="fa_box primary_color" @click="apply">
            <i class="fa fa-share"></i>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        apply() {
            if (this.params.targetField) {
				let val;
				if (this.params.asPercentage === true) {
					val = this.params.value * 100;
				} else {
                	val = this.params.value;
				}
				this.params.data[this.params.targetField] = val;
            }

            if (this.params.apply) {
                this.params.apply(this.params);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base_variables.scss";

.apply_value_cell {
	$fa-box-size: 21px;
	$fa-box-icon-margin: 5px;

    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    i {
        font-size: 15px;
    }

    .fa_box {
        min-height: $fa-box-size;
        min-width: $fa-box-size;
        margin-left: $fa-box-icon-margin;
        text-align: center;
        line-height: $fa-box-size;
        border-radius: 4px;
        cursor: pointer;
        background: #8C939B;
        color: #F5F6F7;
    }

    .fa_box.primary_color {
        background: $accent-background-color;
    }

    .fa_box.primary_color:hover {
        background: $accent-background-color-hover;
    }

	.apply_value_icon {
		margin-right: $fa-box-icon-margin;
		font-size: $fa-box-size;
	}

}
</style>
